import React from "react"

import PricePage from "../../components/CatalogMetal/PricePage"
import { metalCars } from "../../components/CatalogMetal/data"

const KatalizatorPage = () => <PricePage data={metalCars[3]} />

export default KatalizatorPage
